<template>
  <div class="mb-8">
    <v-card class="mx-auto mb-3">
      <div id="filters">
        <template>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0">{{ $t("APPLICATIONS") }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-btn
              v-if="!$vuetify.breakpoint.mdAndUp"
              :to="{name:'StudentNominate'}"
              color="secondary"
              dark
          >{{ $t("STUDENT_NOMINATE_APPLICATION") }}
          </v-btn>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12">
                  <v-select
                      v-model="appStatus"
                      :items="serverTranslateArray(this.status, 'name')"
                      :label="$t('APPLICATION_CASES')"
                      item-text="name"
                      item-value="mongo_id"
                      outlined
                      small-chips
                  >
                  </v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.yearId"
                      :items="serverTranslateArray(this.years, 'name')"
                      :label="$t('ACADEMIC_YEAR')"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.semesterId"
                      :items="serverTranslateArray(this.semesters, 'name')"
                      :label="$t('ACADEMIC_SEMESTER')"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="ma-0" cols="12" lg="4" md="6" sm="6" xs="6">
                  <v-select
                      v-model="filterItems.certificatesCategoryFilter"
                      :items="serverTranslateArray(this.certificateCategoriesList, 'name')"
                      :label="$t('CERTIFICATE')"
                      item-text="name"
                      item-value="id"
                      outlined
                      @change="selectCertType()"
                  ></v-select>
                </v-col>

                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4" xs="4">
                  <v-select
                      v-model="filterItems.certificateTypeFilter"
                      :items="serverTranslateArray(this.certificateTypesList, 'name')"
                      :label="$t('SPECIALIZATION')"
                      item-text="name"
                      item-value="id"
                      outlined
                      @change="selectCertType()"
                  ></v-select>

                </v-col>
                <v-col v-if="(filterItems.certificateTypeFilter == 22 && foreignCertificatesList.length) || (filterItems.certificateTypeFilter == 61 && egyptianCertificatesList.length)" class="ma-0" cols="12" lg="4" md="4"
                       sm="4"
                >
                  <v-select
                      v-model="certificateForeignId"
                      :items="filterItems.certificateTypeFilter == 22 ? serverTranslateArray(this.foreignCertificatesList, 'name') : serverTranslateArray(this.egyptianCertificatesList, 'name') "
                      :label="$t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME')"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4">
                  <v-select
                      v-model="filterItems.countryId"
                      :disabled="filterItems.certificatesCategoryFilter !== 17"
                      :items="serverTranslateArray(this.countriesList, 'name')"
                      :label="$t('ADMISSION_DATA.STEP2.CERT_FROM_COUNTRY')"
                      :value="filterItems.countryId"
                      item-text="name"
                      item-value="id"
                      outlined

                  ></v-select>

                </v-col>

                 <v-col class="ma-0" cols="4" lg="4" md="4" sm="4" xs="4">
                  <v-select
                      v-model="filterItems.preQualYearId"
                      :items="serverTranslateArray(this.years, 'name')"
                      :label="$t('ADMISSION_DATA.STEP2.YEAR')"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>


              </v-row>
              <v-row>
                <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                  <v-menu
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="startApplicationDate"
                          :label="$t('APPLY_APPLICATION_DATE') +$t('FROM')"
                          :rules="startDateRules"
                          clearable
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="startApplicationDate"
                        :max="maxDate"
                        :min="minDate"
                        @input="startDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                  <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          ref="endDate"
                          v-model="endApplicationDate"
                          :label="$t('APPLY_APPLICATION_DATE') +$t('TO')"
                          :rules="endDateRules"
                          clearable
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"

                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="endApplicationDate"
                        :max="maxDate"
                        :min="minDate"
                        @input="endDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>

              </v-row>
              <v-row>
                <v-col class="ma-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-checkbox
                      v-model="withDesiresChecked"
                      :label="$t('VIEW_STUDENTS_WITH_DESIRES')"
                      class="ma-0"
                      color="primary"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0 my-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-radio-group v-model="searchWithId" class="ma-0" row>
                    <v-radio :label="$t('STUDENT_NAME')" value="1"></v-radio>
                    <v-radio :label="$t('IDENTITY')" value="2"></v-radio>
                    <v-radio :label="$t('APPID')" value="3"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col v-if="searchWithId==='2'" class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="identityNum"
                      :label="$t('WithIDENTITYTEXT')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>

                <v-col v-if="searchWithId==='3'"
                       class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="appId"
                      :label="$t('WITHAPPID')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>


                <v-col v-if="searchWithId==='1'"
                       class="py-0"
                       cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-autocomplete
                      v-model="studentId"
                      :items="students"
                      :label="$t('WithNAMETEXT')"
                      :loading="searchIsLoading"
                      :search-input.sync="studentSearch"
                      clearable
                      item-text="name"
                      item-value="id"
                      no-filter
                      outlined
                      return-object
                  ></v-autocomplete>
                </v-col>

              </v-row>
              <v-card-actions class="pa-0">
                <v-container class="px-0">
                  <v-row>
                    <v-col class="pa-1" cols="auto">

                      <v-btn
                          class="mx-2"
                          color="primary"
                          @click="showScopeTreeFn()">
                        {{ $t('SCOPE') }}
                        <v-icon right>mdi-navigation</v-icon>
                      </v-btn>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col class="pa-1" cols="auto">
                      <v-btn color="primary" dark @click="searchAppliactions">
                        {{ $t("SEARCH") }}
                      </v-btn>

                    </v-col>
                    <v-col class="pa-1 mx-2" cols="auto">
                      <v-btn
                          class="white--text"
                          color="darken3"
                          @click="reset"
                      >
                        {{ $t("RESET") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-form>
        </template>
      </div>
    </v-card>
    <v-card class="mx-auto" outlined>
      <div id="inspire">

        <v-data-table
            :footer-props="{
               showFirstLastPage: true,
               firstIcon: 'mdi-arrow-collapse-left',
               lastIcon: 'mdi-arrow-collapse-right',
               prevIcon: 'mdi-arrow-left',
               nextIcon: 'mdi-arrow-right',
               itemsPerPageOptions: [10, 20, 30, 40,50,100,500,1000]
               }"
            :headers="headers"
            :hide-default-footer="applications.length > 0 ? false : true"
            :items="applications"
            :items-per-page="10"
            :loading="loading"
            :options.sync="appOptions"
            :server-items-length="total"
            class="elevation-1 pointer"
            @click:row="viewApplication"
        >
          <template v-slot:item.studentName="{ item }">
            {{ serverTranslate(item.studentName) }}
          </template>

          <template v-slot:item.facultyName="{ item }">
            {{ serverTranslate(item.facultyName) }}
          </template>
          <template v-slot:item.certificateType="{ item }">
            {{ serverTranslate(item.certificateType) }} - {{ serverTranslate(item.certificateName) }}
          </template>

          <template v-slot:item.studentTotal="{ item }">
            {{ item.studentPercentage }}
          </template>

          <template v-slot:item.studentTotal="{ item }">
            {{ item.studentTotal }}
          </template>

          <template v-slot:item.certifiedTotal="{ item }">
            {{ item.certifiedTotal }}
          </template>

          <template v-slot:item.applicationStatus="{ item }">
            {{ getAppStatusText(item.applicationStatus) }}
          </template>

          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title> {{ title }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:footer.page-text="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('PAGE_TEXT') }} {{ props.itemsLength }}
          </template>
          <template v-if="canAcceptRefuseWait" v-slot:item.actions="{ item }">
            <v-tooltip v-if=" ['1','3','7','9'].includes(item.applicationStatus) " top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon class="mx-2" color="green" meduim @click.stop="acceptRefuse(1, item)">mdi-check-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("ACCEPT_APPLICATION") }}</span>
            </v-tooltip>
            <v-tooltip v-if="  ['1','2','7','9'].includes(item.applicationStatus)" top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="acceptRefuse(0, item)">
                  <v-icon class="mx-2" color="red" meduim>mdi-close-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("REJECT_APPLICATION") }}</span>
            </v-tooltip>

            <v-tooltip v-if="item.applicationStatus>0" top>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="printApplication(item.applyId)" v-on="on">
                  <v-icon color="blue" small>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("PRINT") }}</span>
            </v-tooltip>


            <v-tooltip v-if="item.applicationStatus>0" top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="downloadZip(item.applyId,item.studentId)">
                  <v-icon color="green" small>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("DOWNLOAD_STUDENT_ATTACHMENT") }}</span>
            </v-tooltip>


              <v-tooltip color="secondary white--text" bottom v-if="['0','-2',0,-2].includes(item.applicationStatus)">
                       <template v-slot:activator="{ on }">
                         <v-btn icon v-on="on">
                           <v-icon
                              medium
                              color="error"
                              class="mx-2"
                              @click.stop="deleteApplication(item)"
                            >
                              mdi-delete
                            </v-icon>
                         </v-btn>
                       </template>
                       <span>{{ $t("DELETE") }}</span>
                     </v-tooltip>

          </template>
        </v-data-table>
      </div>
    </v-card>
    <pr-ApplicationDetails/>
    <pr-scope v-if="showScopeTree == true" :key="componentKey" :scopeFullPath="false" v-on:setScope="onScopeChanged"/>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>
  </div>
</template>

<script>
import serverTranslations from "@/mixins/serverTranslations";
import ShowApplicationDetails from "@/components/modules/studentData/ManageApplications/ShowApplicationDetails";
import scope from "@/components/shared/ScopeTree.vue"
import {EventBus} from "@/plugins/bus";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import globalMethodsMixin from "@/mixins/globalMethods.ts";


export default {
  name: "List",
  components: {
    "pr-scope": scope,
    "pr-ApplicationDetails": ShowApplicationDetails,
    "pr-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslations, globalMethodsMixin],

  mounted() {
    this.getFilters();
    this.searchAppliactions(true);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const mv = this;
    EventBus.$on("updateRunListAfterAction", () => {
      mv.searchAppliactions();
    });
  },
  watch: {
    searchWithId() {
      this.studentId = null;
      this.students = [];
      this.studentSearch = "";
      this.identityNum = "";
    },
    appOptions: {
      handler() {
        this.searchAppliactions();
      },
      deep: true,
    },
    studentSearch(val) {
      if (!val || val.length < 3) {
        this.students = [];
        return false;
      }
      if (this.searchIsLoading) return;
      const phraseLang = this.isRTL(val) ? "ar" : "en"
      const data = {
        searchData: val,
        semesterId: this.activeAcademicSemester.id,
        yearId: this.activeAcademicYear.id,
        //  appStatus: this.appStatus
      }
      this.searchIsLoading = true;
      this.$http.post("/api/students_admission_apps/search_student/", data)
          .then(
              res => {
                res = res.data.data;
                this.students = res.students.map(item => {
                  return {"id": item.studentId, "name": this.serverTranslateCustom(item.studentName, phraseLang)}
                });
              },
              err => {
                this.showToasted("error", err.response.data.message)
              }
          )
          .then(() => (this.searchIsLoading = false));

    },
  },
  computed: {
    canAcceptRefuseWait() {
      return this.$store.getters.hasPermission("students_admission_apps.can_accept_refuse_wait_app");
    },
    isSearchedWithName() {
      return this.searchWithId === "1";

    },
    isSearchedWithAppId() {
      return this.searchWithId === "3";
    },
    endDateRules() {
      return [
        v =>
            new Date(this.endApplicationDate) >= new Date(this.startApplicationDate) ||
            this.$t("DATE_FROM_TO_VALIDATION")
      ]
    },
    startDateRules() {
      return [
        v => !this.endApplicationDate || new Date(v) <= new Date(this.endApplicationDate) || this.$t("DATE_FROM_TO_VALIDATION")

      ];
    },
    activeAcademicYear() {
      return this.$store.getters.getActiveAcademicYear;
    },
    activeAcademicSemester() {
      return this.$store.getters.getActiveAcademicSemester;
    },
    title() {
      return this.$t('APPLICATIONS_LIST_TITLE', {
        year: this.filterItems.yearName,
        semester: this.serverTranslate(this.filterItems.semesterName),
        faculty: this.serverTranslate(this.$store.state.Auth.facultyName) || ''
      });
    },
    headers() {
      return [
        {
          text: this.$t("STUDENT_NAME"),
          align: "center",
          sortable: true,
          value: "studentName"
        },
        {
          text: this.$t("IDENTITY"),
          align: "center",
          sortable: false,
          value: "identityNumber"
        },
        {
          text: this.$t("APPID"),
          align: "center",
          sortable: false,
          value: "appNum"
        },
        {
          text: this.$t("DESIRE_ORDER"),
          align: "center",
          sortable: true,
          value: "desireNumber"
        },
        {
          text: this.$t("ADMISSION_DATA.APPLICATION_DATE"),
          align: "center",
          sortable: true,
          value: "applyDate"
        },
        {
          text: this.$t("ADMISSION_DATA.STEP4.PAIDDATE"),
          align: "center",
          sortable: true,
          value: "paymentDate"
        },

        {
          text: this.$t("FACULTY"),
          align: "center",
          sortable: true,
          value: "facultyName"
        },
        {
          text: this.$t("CERTIFICATE"),
          align: "center",
          sortable: true,
          value: "certificateType"
        },
        {
          text: this.$t("UserData.CERTIFICATE_PERC"),
          align: "center",
          sortable: true,
          value: "studentPercentage"
        }, {
          text: this.$t("TOTAL_DEGREE"),
          align: "center",
          sortable: true,
          value: "studentTotal"
        },
        {
          text: this.$t("CERTIFIED_DEGREE"),
          align: "center",
          sortable: true,
          value: "certifiedTotal"
        },
        {
          text: this.$t("APPLICATION_CASES"),
          align: "center",
          sortable: true,
          value: "applicationStatus"
        },
        {
          text: this.$t("ACTIONS"),
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  data() {
    return {
      valid: true,
      loading: false,
      endDateMenu: false,
      startDateMenu: false,
      startApplicationDate: "",
      endApplicationDate: "",
      withDesiresChecked: false,
      filterItems: {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: "",
        certificatesCategoryFilter: '',
        certificateTypeFilter: '',
        countryId: '',
        preQualYearId: ''
      },
      certificateForeignId: '',
      semesters: [],
      years: [],
      scopes: [],
      certificateCategoriesList: [],
      foreignCertificatesList: [],
      egyptianCertificatesList: [],
      certificateTypesList: [],
      countriesList: [],
      currentYear: {},
      currentSemester: {},
      studentsNumbers: null,
      studentSearch: "",
      searchWithId: "1",
      searchWithAppId: "1",
      status: [],
      appStatus: "all",
      searchIsLoading: false,
      students: [],
      applications: [],
      identityNum: "",
      appId: "",
      total: 0,
      appOptions: {},
      studentId: "",
      showScopeTree: false,
      componentKey: 0
    };
  },
  methods: {
    printApplication(itemId) {
      this.$router.push({
        name: "PrintApplication",
        params: {
          id: itemId
        }
      });
    },
    downloadZip(applyId, studentId) {
      return this.$http.post(
          "/api/students_admission_apps/get_files_download/",
          {applyId, studentId},
          {responseType: 'blob'}
      )
          .then(async response => {
            const blob = response.data;
            if (blob.size < 100) {
              this.showToasted("error", this.$t("NO_FILE"));
              return;
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `application_${applyId}.zip`;
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(err => {
            this.showToasted("error", err?.response?.message || this.$t("DOWNLOAD_ERROR"));
          });
    },
    selectCertType() {

      const selectedCert = this.filterItems.certificatesCategoryFilter;
      if (!selectedCert) {
        this.filterItems.countryId = null;
      } else if (selectedCert != 17 && this.countriesList.length > 0) {
        this.filterItems.countryId = this.countriesList[0].id;

      }

      return this.$http
          .post("/api/students_admission_apps/get_certificate_type_filter/", {
            categoryId: this.filterItems.certificatesCategoryFilter || 0
          })
          .then(response => {
                const data = response.data.data;
                this.certificateTypesList = data.certificatesTypes['basic_category_items']
              },
              err => {
                this.showToasted("error", err.response.data.message);
              })
          .then(() => (this.loading = false));
    },
    viewApplication(item) {
      EventBus.$emit('showApplicationDetails', item.applyId, item.studentId, false);
    },
    showScopeTreeFn() {
      this.showScopeTree = true;
      this.componentKey += 1;
    },
    getFilters(facultyId = null) {
      return this.$http
          .post("/api/students_admission_apps/list_application_filters/", {
            facultyId: facultyId || "",
            yearId: this.activeAcademicYear.id || 0,
            semesterId: this.activeAcademicSemester.id || 0
          })
          .then(response => {
                const data = response.data.data;
                const modifiedStatus = [{
                  name: this.$t('ALL'),
                  id: 'all',
                  'mongo_id': 'all',
                  'ordering': 0
                }, ...data.applicationStatus]
                this.semesters = data.Semesters;
                this.years = data.years;
                this.status = modifiedStatus;
                this.appStatus = "all"
                this.certificateCategoriesList = data.certificateCategories['basic_category_items'];
                this.foreignCertificatesList = data.foreignCertificates;
                this.egyptianCertificatesList = data.egyptianCertificates;
                this.countriesList = data.countries['countriesList'];
                this.currentYear = this.years.filter(year => parseInt(year.active) === 1)[0];
                this.filterItems.yearId = this.currentYear.id || 0;
                this.filterItems.yearName = this.currentYear.name || "";
                this.currentSemester = this.semesters.filter(semester => parseInt(semester.active) === 1)[0];
                this.filterItems.semesterId = this.currentSemester.id || 0;
                this.filterItems.semesterName = this.currentSemester.name || "";
              },
              err => {
                this.showToasted("error", err.response.data.message);
              })
          .then(() => (this.loading = false));
    },

    initializeList() {
      return new Promise((resolve, reject) => {
        const data = this.searchedData();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$http
              .post("/api/students_admission_apps/list_applications/", data)
              .then(
                  res => {
                    this.applications = [];
                    const items = res.data.data.results;
                    const total = res.data.data.total;
                    resolve({
                      items,
                      total,
                    });
                  },
                  err => {
                    this.applications = [];
                    this.$toasted.show(this.serverTranslate(err.response.data.message),
                        {
                          type: "error",
                          icon: "error_outline",
                          position: "bottom-left",
                          duration: 5000,
                          theme: "bubble"
                        }
                    );
                  }
              );
          this.loading = false;
        }, 1000);
      });
    },

    searchedData() {
      this.loading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.appOptions
      const data = {
        studentId: !this.studentId || !this.studentId.id ? "" : this.studentId.id,
        yearId: this.filterItems.yearId || this.activeAcademicYear.id || 0,
        semesterId: this.filterItems.semesterId || this.activeAcademicSemester.id || 0,
        identityType: this.searchWithId || "",
        searchText: this.identityNum || this.appId || "",
        appStatus: (this.appStatus && this.appStatus != 'all' && Array.isArray(this.appStatus) ? this.appStatus.flat() : ""),
        //appStatus: (([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'all'].includes(this.appStatus)) ? this.appStatus : ''),
        certificateTypeId: this.filterItems.certificateTypeFilter || "",
        countryId: this.filterItems.countryId || "",
        preQualYearId: this.filterItems.preQualYearId || "",
        certificateCategoryId: this.filterItems.certificatesCategoryFilter || "",
        startApplicationDate: this.startApplicationDate,
        endApplicationDate: this.endApplicationDate,
        certificateForeignId: this.certificateForeignId || "",
        withDesiresChecked: this.withDesiresChecked,
        page: page,
        pageSize: itemsPerPage
      }
      if (sortBy.length === 1 && sortDesc.length === 1) {
        data.orderType = sortDesc[0] ? "asc" : "desc";
        data.orderBy = sortBy[0]
      }
      return data
    },
    searchAppliactions(resetPageNum = false) {
      if (resetPageNum) {
        this.appOptions.page = 1;
        this.appOptions.sortBy = [];
        this.appOptions.sortDesc = [];
      }
      this.initializeList()
          .then(data => {
            this.applications = data.items;
            this.total = data.total;
          });
    },
    reset() {
      this.filterItems.yearId = this.currentYear.id;
      this.filterItems.semesterId = this.currentSemester.id;
      this.filterItems.certificatesCategoryFilter = '';
      this.filterItems.certificateTypeFilter = '';
      this.filterItems.countriesList = '';
      this.filterItems.preQualYearId = '';
      this.studentId = null;
      this.students = [];
      this.identityNum = "";
      this.searchWithId = "1";
      this.appStatus = "all"
      this.studentSearch = "";
      this.startApplicationDate = "";
      this.certificateForeignId = "";
      this.endApplicationDate = "";

      this.searchAppliactions(true);
    },
    onScopeChanged(changed) {
      if (changed)
        this.searchAppliactions(true);
    },
    acceptRefuse(state, item) {
      let confMsg = ""
      if (state === 1 && item.appsCount > 1 && item.appsAcceptedCount > 0) {
        confMsg = "CONF_ACCEPT_APP_NEGLECT_OTHER"
      } else if (state === 1 && item.appsCount > 1) {
        confMsg = "CONF_ACCEPT_APP_NEGLECT_REFUSE_OTHER"
      } else if (state === 1) {
        confMsg = "CONF_ACCEPT_APP"
      } else {
        confMsg = "CONF_REFUSE_APP"
      }
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", confMsg)
          .then(res => {
                if (res) {
                  this.$http
                      .put("/api/students_admission_apps/accept_reject_application/", {
                        applicationId: item.applyId,
                        studentId: item.studentId,
                        action: state,
                        studentName: this.serverTranslate(item.studentName)
                      })
                      .then(response => {
                        this.showToasted("success", response.data.message);
                        this.initializeList()
                            .then(data => {
                              this.applications = data.items;
                              this.total = data.total;
                            });
                      })
                      .catch(errors => {
                        this.showToasted("error", errors.response.data.message);
                      });
                }
              },
              err => {
                this.showToasted("error", err.response.data.message)
              })
    }
    ,deleteApplication(item) {
       const ConfirmMsg = this.$t("CONFIRM_MESSAGES.DELETE_DRAFT_CONFIRMATION",
           {appStatus:this.getAppStatusText(item.applicationStatus),AppId:item.applyId,stuName:this.serverTranslate(item.studentName)});
         this.$refs.confirm
         .open("CONFIRMATION_MESSAGE", ConfirmMsg,
         {
                type: "warning",
                confirmText: "DELETE",
                confirmColor: "error"
            })

         .then(confirm => {
           if (confirm) {
             const data = {
                applicationId:item.applyId,
                studentId: item.studentId,
             };
             this.$http
             .delete("/api/students_admission_apps/delete_application/", {data:data})
             .then(response => {
                        this.showToasted("success", response.data.message);
                        this.initializeList()
                            .then(data => {
                              this.applications = data.items;
                              this.total = data.total;
                            });
                      },
               err => {
                 this.$toasted.show(
                   this.serverTranslate(err.response.data.message),
                   {
                     type: "error",
                     icon: "error_outline",
                     theme: "bubble",
                     position: "bottom-left",
                     duration: 3000
                   }
                 );
               }
             );
           }
         });
      },
  }
};
</script>
